// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

const WorkingDayList = () => import('@/modules/settings/views/management/WorkingDayList')
const ManageDropdownOptionList = () => import('@/modules/settings/views/management/ManageDropdownOptionList')
const UserPhoneExtensionBase = () => import('@/modules/settings/views/management/UserPhoneExtensionBase') 
const UserExtensionUnAssigned = () => import('@/modules/settings/views/management/UserExtensionUnAssigned')
const UserExtensionAssigned = () => import('@/modules/settings/views/management/UserExtensionAssigned') 
const TaliupFeatureList = () => import('@/modules/settings/views/management/TaliupFeatureList')
const ManageRateChangeOptionList = () => import('@/modules/settings/views/management/ManageRateChangeOptionList')
const ManageCommonDefaultList = () => import('@/modules/settings/views/management/ManageCommonDefaultList')
const ManageCallerIds = () => import('@/modules/settings/views/management/ManageCallerIds')

var routes = [
    {
        path: '/settings',
        redirect: '/settings/working-days',
        component: DefaultContainer,
        children: [
            {
				path: '/settings/working-days',
                name: 'WorkingDayList',
                component: WorkingDayList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
            {
				path: '/settings/dropdown-options',
                name: 'Manage Dropdown List',
                component: ManageDropdownOptionList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
            {
                path: '/settings/user-phone-extensions',
                name: 'UserPhoneExtensionBase',
                redirect: '/settings/user-phone-extensions/unassigned',
                component: UserPhoneExtensionBase,
                children: [
                    {
                        path: '/settings/user-phone-extensions/unassigned',
                        name: 'UnAssigned Extension',
                        component: UserExtensionUnAssigned,
                        meta: {
                            requiresAuth: true,
                            permission: false,
                            tab: 'unassigned-list',
                        },
                    },
                    {
                        path: '/settings/user-phone-extensions/assigned',
                        name: 'Assigned Extension',
                        component: UserExtensionAssigned,
                        meta: {
                            requiresAuth: true,
                            permission: false,
                            tab: 'assigned-list',
                        },
                    },
                    
                ]
            },
            {
                path: '/settings/taliup-features',
                name: 'TaliupFeatureList',
                component: TaliupFeatureList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                    tab: 'taliup-features',
                },
            },
            {
                path: '/settings/rate-change-options',
                name: 'ManageRateChangeOptionList',
                component: ManageRateChangeOptionList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                    tab: 'rate-change-options',
                },
            },
            {
                path: '/settings/common-defaults',
                name: 'ManageCommonDefaultList',
                component: ManageCommonDefaultList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                    tab: 'common-defaults',
                },
            },
            {
                path: '/settings/caller-ids',
                name: 'ManageCallerIds',
                component: ManageCallerIds,
                meta: {
                    requiresAuth: true,
                    permission: false,
                    tab: 'caller-ids',
                },
            },
        ]
    },
];

export default routes;
